
$(document).ready(function(){
  var slidesInView = $('.collection-list__slider').data('products-in-view');
  $('.collection-list__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: slidesInView,
    slidesToScroll: slidesInView,
    prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
    nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });
  var slidesInView = $('.featured-collection__slider').data('products-in-view');
  $('.featured-collection__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: slidesInView,
    slidesToScroll: slidesInView,
    prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
    nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });

  setTimeout(function(){
    $(".product-recommendations__slider").show();
    var slidesInView = $('.product-recommendations__slider').data('products-in-view');
    $('.product-recommendations__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: slidesInView,
      slidesToScroll: slidesInView,
      prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
      nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    });
  }, 3000);
});

// $('.fcwi__slider').slick({
//   dots: false,
//   arrows: true,
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
//   nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: false
//       }
//     }
//   ]
// });

$('.slideshow-with-products__slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.product-list-container',
  prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
  nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>'
});
$('.product-list-container').slick({
  dots: false,
  arrows: false,
  infinite: true,
  asNavFor: '.slideshow-with-products__slider',
  focusOnSelect: true,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

function initProductGallerySlick() {
  var $mainphoto = $('.section-product-template .product-area__mainphoto');
  var $thumbnails = $('.section-product-template .product-area__thumbnails');

  if (!$mainphoto.length) {
    return;
  }

  if (!$mainphoto.hasClass('slick-initialized')) {
    $mainphoto.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
      nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
      asNavFor: '.section-product-template .product-area__thumbnails'
    });
  }

  if ($thumbnails.length && !$thumbnails.hasClass('slick-initialized')) {
    $thumbnails.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.section-product-template .product-area__mainphoto',
      dots: true,
      centerMode: true,
      prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/larrow.png?v=91120459931114269961788717123"></div>',
      nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/365/assets/rarrow.png?v=95456879295688143981788717123"></div>',
      focusOnSelect: true,
      infinite: true
    });
  }

  if ($mainphoto.hasClass('slick-initialized')) {
    $mainphoto.slick('setPosition');
  }
  if ($thumbnails.hasClass('slick-initialized')) {
    $thumbnails.slick('setPosition');
  }
}

$(document).ready(initProductGallerySlick);

(function () {
  var customerSelectedVariant = false;

  function getProductContext(element) {
    var $context = $(element).closest('.product-area, [data-section-id], .shopify-section');
    return $context.length ? $context : $(document);
  }

  function getTargetSlideIndex($slider, selector) {
    var $target = $slider.find(selector).not('.slick-cloned').first();
    if (!$target.length) return;

    var slickIndex = $target.attr('data-slick-index');
    if (typeof slickIndex !== 'undefined') {
      return parseInt(slickIndex, 10);
    }

    return $target.index();
  }

  function syncGalleryToMedia(mediaId, context) {
    if (!mediaId) return;

    mediaId = String(mediaId);

    var $context = context && context.length ? context : $(document);
    var $mainGallery = $context.find('.product-area__mainphoto.slick-initialized').first();
    var $thumbGallery = $context.find('.product-area__thumbnails.slick-initialized').first();

    if (!$mainGallery.length) {
      $mainGallery = $('.product-area__mainphoto.slick-initialized').first();
    }
    if (!$thumbGallery.length) {
      $thumbGallery = $('.product-area__thumbnails.slick-initialized').first();
    }

    if ($mainGallery.length) {
      var mainIndex = getTargetSlideIndex($mainGallery, '.main-item[data-media-id="' + mediaId + '"]');
      if (typeof mainIndex !== 'undefined' && !isNaN(mainIndex)) {
        $mainGallery.slick('slickGoTo', mainIndex, true);
        $mainGallery.slick('setPosition');
      }
    }

    if ($thumbGallery.length) {
      var thumbIndex = getTargetSlideIndex($thumbGallery, '.thumb[data-media-id="' + mediaId + '"]');
      if (typeof thumbIndex !== 'undefined' && !isNaN(thumbIndex)) {
        $thumbGallery.slick('slickGoTo', thumbIndex, true);
        $thumbGallery.slick('setPosition');
      }
    }
  }

  function syncGalleryFromOption(select) {
    var mediaId = $(select).find('option:selected').attr('data-media-id');
    if (!mediaId) return;

    var $context = getProductContext(select);
    syncGalleryToMedia(mediaId, $context);

    setTimeout(function () {
      syncGalleryToMedia(mediaId, $context);
    }, 80);
  }

  $(document).on('change', '.product-detail__form__options select', function () {
    customerSelectedVariant = true;
    syncGalleryFromOption(this);
  });

  function showVariantMedia(variant, context) {
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;
    syncGalleryToMedia(variant.featured_media.id, context);
  }

  $(document).on('variantChanged', function (event, variant) {
    if (!customerSelectedVariant) return;

    var $eventTarget = $(event.target);
    if (!$eventTarget.find('.product-area__mainphoto').length && !$eventTarget.closest('.product-area').length) return;
    showVariantMedia(variant, $eventTarget);
  });
})();

(function () {
  function updateMotifSelectImage(select) {
    var $select = $(select);
    var $selectedOption = $select.find('option:selected');
    var imageSrc = $selectedOption.attr('data-image');
    var $prettySelect = $select.closest('.pretty-select');
    var $text = $prettySelect.find('.text').first();

    if (!$text.length || !$select.find('option[data-image]').length) return;

    $text.find('.motif-select-thumbnail').remove();
    $prettySelect.toggleClass('has-motif-thumbnail', !!imageSrc);

    if (imageSrc) {
      $('<img>', {
        src: imageSrc,
        alt: '',
        class: 'motif-select-thumbnail',
        'aria-hidden': 'true'
      }).prependTo($text);
    }
  }

  function initMotifSelectImages(context) {
    $(context || document).find('.product-detail__form__options select').each(function () {
      if ($(this).find('option[data-image]').length) {
        updateMotifSelectImage(this);
      }
    });
  }

  $(document).on('change keyup', '.product-detail__form__options select', function () {
    updateMotifSelectImage(this);
  });

  $(document).ready(function () {
    initMotifSelectImages(document);
    setTimeout(function () {
      initMotifSelectImages(document);
    }, 250);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initMotifSelectImages(event.target);
  });
})();

$(document).on('change keyup', '.filter .pretty-select select.replaced', function () {
  $(this).siblings('.text').find('.value').html($(this).find(':selected').html());
});

$(document).on('change keyup', '.section-product-template .product-detail__form__options .pretty-select select.replaced', function () {
  $(this).siblings('.text').find('.value').html($(this).find(':selected').html());
});

$(document).ready(function(){
  if($(window).width() < 768){
    $(".image-with-text .image-with-text__text .image-with-text__text__wrap").css("max-width", $(window).width());
  }
});

$(".product-area__mainphoto .main-item").click(function(){
  $.magnificPopup.open({
    items: {
      src: '#product-image-modal'
    },
    type: 'inline',
    callbacks: {

        open: function() {                       
            $('body').addClass('disableScroll');  
        },                                        

        close: function() {                      
            $('body').removeClass('disableScroll'); 
        },                                        

    }
  });
});

function getMaxChildWidth(sel) {
    max = 0;
    $(sel).children().each(function(){
        c_width = parseInt($(this).width());
        if (c_width > max) {
            max = c_width;
        }
    });
    return max;
}
$('.cc-announcement .marquee-text .cc-announcement__inner').css('min-width', getMaxChildWidth('#site-control.fixed .cc-announcement'));

  var w = $(window).width()/3 - 40;
  if(w > 550){
    w = 550;
  }
  var border = $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .icon-slideshow-border").width();
  var l = w + (border - w) - 40;
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only").css("margin-left", w+"px");
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .slideshow--border").css("left", -l+"px");
  if($(window).width() > 991){
    $(".slideshow--border-left .slide .overlay .inner").css("width", w-60 +"px");
  }

$(window).resize(function(){
  var w = $(window).width()/3 - 40;
  if(w > 550){
    w = 550;
  }
  var border = $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .icon-slideshow-border").width();
  var l = w + (border - w) - 40;
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only").css("margin-left", w+"px");
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .slideshow--border").css("left", -l+"px");
  if($(window).width() > 991){
    $(".slideshow--border-left .slide .overlay .inner").css("width", w-60 +"px");
  }
});
